import React, { useEffect, useState } from "react";

async function sha256Hex(text) {
  const data = new TextEncoder().encode(text.trim().toLowerCase());
  const buf = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export default function UserAvatar({ user, size = "sm" }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);
    if (!user?.email) return;
    sha256Hex(user.email)
      .then((hash) => {
        if (active) setSrc(`https://www.gravatar.com/avatar/${hash}?s=128&d=404`);
      })
      .catch(() => active && setFailed(true));
    return () => { active = false; };
  }, [user?.email]);

  const name = user?.full_name || user?.email || "?";
  const sizeClass =
    size === "xs" ? "w-6 h-6 text-[10px]" : size === "sm" ? "w-8 h-8 text-xs" : size === "md" ? "w-10 h-10 text-sm" : "w-14 h-14 text-base";

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setFailed(true)}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0`}
        style={{ boxShadow: "0 4px 6px -1px rgba(0,0,0,0.25), 0 2px 4px -1px rgba(0,0,0,0.18)" }}
      />
    );
  }

  const initials = name.trim().split(/\s+/).map((p) => p[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div
      className={`${sizeClass} rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold flex-shrink-0`}
      title={user?.email}
      style={{ boxShadow: "0 4px 6px -1px rgba(0,0,0,0.25), 0 2px 4px -1px rgba(0,0,0,0.18)" }}
    >
      {initials}
    </div>
  );
}